"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCondimentFilterActions = void 0;
var react_1 = require("react");
var useCondimentFilterActions = function (_a) {
    var condiments = _a.condiments, condimentTypes = _a.condimentTypes;
    var _b = (0, react_1.useState)("ALL"), selectedTypeFilter = _b[0], setSelectedTypeFilter = _b[1];
    var typeFilters = (0, react_1.useMemo)(function () {
        var typeOptions = condimentTypes.map(function (condimentType) { return ({
            label: condimentType.type.toUpperCase(),
            value: condimentType.type,
        }); });
        return __spreadArray([{ label: "ALL", value: "ALL" }], typeOptions, true);
    }, [condiments]);
    var onSetSelectedType = (0, react_1.useCallback)(function (value) {
        setSelectedTypeFilter(value);
    }, []);
    var filterActions = (0, react_1.useMemo)(function () { return [
        {
            key: "type",
            label: "Type",
            value: selectedTypeFilter,
            items: typeFilters,
            onChange: onSetSelectedType,
        },
    ]; }, [typeFilters, selectedTypeFilter, onSetSelectedType]);
    var resetFilters = (0, react_1.useCallback)(function () {
        setSelectedTypeFilter("ALL");
    }, []);
    (0, react_1.useEffect)(function () {
        resetFilters();
    }, [resetFilters]);
    return (0, react_1.useMemo)(function () { return ({
        filterActions: filterActions,
        selectedTypeFilter: selectedTypeFilter,
        resetFilters: resetFilters,
    }); }, [filterActions, selectedTypeFilter, resetFilters]);
};
exports.useCondimentFilterActions = useCondimentFilterActions;
exports.default = exports.useCondimentFilterActions;
